export default {
  title: 'Bilan de votre fiscalité',
  subtitle: {
    figures: 'Vos chiffres clés :',
    taxation: 'Votre imposition :',
    levers: 'Leviers d\'actions :'
  }
}
